import React from 'react'

import PopupMenuButton from "../../../../../../core/gd-components/popover-menu/popup-menu-button/popup-menu-button"
import ControlButtonStandard, {
    ControlButtonType
} from "../../../../../../core/gd-components/buttons/control-button/control-button-standard"
import PageSettingsMenuOptions from "./menu-options"
import {PageContentInterface} from "../../page-content-interface"

type Props = {
    className?  : string

    app         : PageContentInterface

    hint        : string
}

export default function AppControlPageSettings(props: Props) {

    const btnComponent = (state: any) => {
        const classes = Classes("m-r-8", props.className, {
            'show-popover': state.showPopover
        })

        return <ControlButtonStandard className = {classes}
                                      type      = {ControlButtonType.PREFERENCES}
                                      hint      = {props.hint}/>
    }

    return <PopupMenuButton offset          = "0 0"
                            btnComponent    = {btnComponent}
                            menuComponent   = {PageSettingsMenuOptions}
                            menuParams      = {{
                                app: props.app
                            }}/>
}

AppControlPageSettings.defaultProps = {
    hint: 'Page settings',
}
